exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn{border:1px solid grey;font-size:3rem;cursor:pointer}.btn,.name-label{padding:.5rem;margin:.5rem}.name-label{font-size:2rem;float:left}.name-label:hover{background-color:grey}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/App.css
// module id = 122
// module chunks = 0